import React, { Component } from "react";
import { connect } from "react-redux";
import SRHCopyright from "./../../../../components/SRHCopyright";
import ReportHeader from "./../../../../components/ReportHeader";
import Printable from "./../../../../components/Printable";
import KeyDriverCircles from "./../../../../components/KeyDriverCircles";
import { Wrapper, Question, Domain, Footer } from "./style.js";
import _ from "lodash";
import clsx from "clsx";
import FiltersFooter from "../FiltersFooter";

class Questions extends Component {
  constructor(props) {
    super(props);
    this.getPage = this.getPage.bind(this);
    this.displayPercentile = this.displayPercentile.bind(this);
    this.getValues = this.getValuesFromQuestion.bind(this);
  }

  getPage(domains, pageNumber, summaryReport, unit, reportType, sutterUnitReport, landscape) {
    const { page, benchmarkFootnote, showInlineValuesOnDonuts } = this.props;
    const { totalRespondents, datasetName, workSettingsSurveyed, actualSurvey } = summaryReport;
    const columns = [];
    const datasetEntityName = summaryReport.datasetEntityName ? summaryReport.datasetEntityName : "Facility";
    const datasetUnitName = summaryReport.datasetUnitName ? summaryReport.datasetUnitName : "Work Setting";
    switch (reportType) {
      case "sutter":
        if (sutterUnitReport) {
          columns.push(
            <h4 className="header-1-of-4">
              Benchmark <br /> Percentile*
            </h4>
          );
          columns.push(
            <h4 className="header-2-of-4">
              Percent <br /> Positive
            </h4>
          );
          columns.push(
            <h4 className="header-3-of-4">
              Affiliate <br /> Percent Positive
            </h4>
          );
          columns.push(
            <h4 className="header-4-of-4">
              Sutter Health <br /> Percent Positive
            </h4>
          );
        } else {
          columns.push(
            <h4 className="header-1-of-3">
              Benchmark <br /> Percentile*
            </h4>
          );
          columns.push(
            <h4 className="header-2-of-3">
              Percent <br /> Positive
            </h4>
          );
          columns.push(
            <h4 className="header-3-of-3">
              Sutter Health <br /> Percent Positive
            </h4>
          );
        }
        break;
      case "facility":
        columns.push(
          <h4 className="header-1-of-2">
            {datasetEntityName} <br /> Percent Positive
          </h4>
        );
        columns.push(
          <h4 className="header-2-of-2">
            {datasetEntityName} <br /> Benchmark Percentile*
          </h4>
        );
        break;
      case "unit":
        columns.push(
          <h4 className="header-1-of-3">
            {datasetUnitName} <br /> Percent Positive
          </h4>
        );
        columns.push(
          <h4 className="header-2-of-3">
            {datasetEntityName} <br /> Percent Positive
          </h4>
        );
        columns.push(
          <h4 className="header-3-of-3" style={{ width: "121px", marginRight: "-3px" }}>
            {datasetUnitName} <br /> Benchmark Percentile*
          </h4>
        );
        break;
      default:
        break;
    }
    return (
      <Printable key={`page-${pageNumber}`} page={page + pageNumber} landscape={landscape}>
        <ReportHeader
          title={`Percent Positive Respondents by Survey Item${pageNumber === 0 ? "" : " (cont.)"}`}
          totalRespondents={totalRespondents}
          workSettingsSurveyed={workSettingsSurveyed}
          datasetName={datasetName}
          unit={unit}
          smallerHeader
          summaryReport={summaryReport}
        />
        {columns}
        <div className="padding-below-header" />
        {domains}
        {/SUTTER_Pulse_PhysicianAmb/.test(actualSurvey) && (
          <KeyDriverCircles showInlineValuesOnDonuts={showInlineValuesOnDonuts} />
        )}
        <Footer>
          <p>* {reportType === "sutter" ? benchmarkFootnote.replace("of facilities ", "") : benchmarkFootnote}</p>
          <p>
            † Benchmark percentile displayed for burnout questions are based on the percent negative (burned out) rather
            than the percent positive percentage.
          </p>
        </Footer>
        <FiltersFooter />
        <SRHCopyright textClass="large-font" />
      </Printable>
    );
  }

  displayPercentile(percentile) {
    if (percentile === "--") {
      return percentile;
    } else if (percentile === 11 || percentile === 12 || percentile === 13) {
      return `${percentile}th`;
    } else if (percentile % 10 === 1) {
      return `${percentile}st`;
    } else if (percentile % 10 === 2) {
      return `${percentile}nd`;
    } else if (percentile % 10 === 3) {
      return `${percentile}rd`;
    } else {
      return `${percentile}th`;
    }
  }

  getValuesFromQuestion(question, currentGroupName, prevGroupName) {
    const { questions, summaryReport } = this.props;
    const { comparativeDatasets } = summaryReport;
    const results = questions.questions[question.column];
    results.column = question.column;
    results.domain = question.domain;
    if (question.customText) {
      results.question = question.customText;
    }
    let positiveIndex = -1;
    let strainedIndex = -1;
    _.forEach(results.data, function (point, index) {
      if (point.name === "Percent Positive") {
        positiveIndex = index;
      } else if (point.name === "Percent Strained") {
        strainedIndex = index;
      }
    });

    let currentIndex = -1;
    let prevIndex = -1;
    if (comparativeDatasets) {
      _.forEach(results.data[0].data, function (point, index) {
        if (point.group_name === currentGroupName) {
          currentIndex = index;
        } else if (point.group_name === prevGroupName) {
          prevIndex = index;
        }
      });
    } else {
      currentIndex = 0;
    }

    let positive = 0;
    let change = 0;
    if (
      (positiveIndex > -1 && results.data[positiveIndex].data[currentIndex]) ||
      (strainedIndex > -1 && results.data[strainedIndex].data[currentIndex])
    ) {
      if (positiveIndex > -1) {
        positive = results.data[positiveIndex].data[currentIndex].percent;
      }
      if (strainedIndex > -1) {
        if (results.domain === "wk") {
          positive = 100 - results.data[strainedIndex].data[currentIndex].percent - results.data[strainedIndex].data[currentIndex].percent_neutral;
        } else {
          positive = results.data[strainedIndex].data[currentIndex].percent;
        }
      }
      let showChange = false;
      if (positiveIndex > -1 && prevIndex > -1) {
        showChange = true;
        change = positive - results.data[positiveIndex].data[prevIndex].percent;
      }
      if (strainedIndex > -1 && prevIndex > -1) {
        showChange = true;
        if (results.domain === "wk") {
          change = positive - (100 - results.data[strainedIndex].data[prevIndex].percent - results.data[strainedIndex].data[prevIndex].percent_neutral);
        } else {
          change = positive - results.data[strainedIndex].data[prevIndex].percent;
        }
      }
      results.positive = positive;
      results.unitPositive = 0;
      results.showChange = showChange;
      results.change = change;
      results.percentile = results.data[0].benchmarks[0] ? results.data[0].benchmarks[0].percentile : "--";
    } else {
      results.insufficientData = true;
    }
    return results;
  }

  render() {
    const { unit, summaryReport, ready, landscape } = this.props;
    const { survey, surveyQuestions, domainPrefixes, comparativeDatasets, configuration } = summaryReport;

    if (ready) {
      let reportType;
      let reportSubType;
      let sutterUnitReport = summaryReport.unit;
      if (!unit && summaryReport.actualSurvey !== "SUTTER_Pulse") {
        reportType = "facility";
      } else if (unit && summaryReport.actualSurvey !== "SUTTER_Pulse") {
        reportType = "unit";
      } else if (summaryReport.actualSurvey === "SUTTER_Pulse") {
        reportType = "sutter";
      }

      if (summaryReport.actualSurvey === "SUTTER_Pulse_PhysicianAcute") {
        reportSubType = "sutter_acute";
      } else if (summaryReport.actualSurvey === "SUTTER_Pulse_PhysicianAmb") {
        reportSubType = "sutter_amb";
      }

      const currentDataset = _.filter(
        _.map(comparativeDatasets && comparativeDatasets.split("||"), function (dataset) {
          return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
        }),
        function (dataset) {
          return dataset.id === "this";
        }
      )[0];
      const currentGroupName = currentDataset && currentDataset.year;

      const prevDataset = _.reduce(
        _.map(comparativeDatasets && comparativeDatasets.split("||"), function (dataset) {
          return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
        }),
        function (highest, next) {
          return (highest.year < next.year || highest.id === "this") && next.id !== "this" ? next : highest;
        }
      );
      const prevGroupName = prevDataset && prevDataset.year;

      const domains = [
        { code: "cultureOverall", name: "Overall Culture Score" },
        { code: "le", name: "Learning Environment" },
        { code: "ll", name: "Local Leadership" },
        { code: "ee", name: "Burnout Climate", negative: true },
        { code: "me", name: "Personal Burnout", negative: true },
        { code: "th", name: "Emotional Thriving" },
        { code: "rc", name: "Emotional Recovery" },
        { code: "tm", name: "Teamwork" },
        { code: "sc", name: "Safety Climate" },
        { code: "wlb", name: "Work / Life Balance", negative: true },
        { code: "go", name: "Growth Opportunities" },
        { code: "ju", name: "Job Certainty" },
        { code: "il", name: "Intentions to Leave", negative: true },
        { code: "dm", name: "Decision Making" },
        { code: "ad", name: "Advancement" },
        { code: "wk", name: "Workload Strain" },
        { code: "dei", name: "DEI / Belonging" },
        { code: "ws", name: "Workforce Safety" },
        { code: "ps", name: "Physical Safety" },
        { code: "gspp", name: "GSPP Wellness" },
        { code: "gme", name: "GME Questions" },
        { code: "hup", name: "Additional Questions" },
        { code: "custfeel", name: "Acquisition Feelings"},
        { code: "custbenefit", name: "Acquisition Benefits"},
        { code: "custfeel2", name: "Feel Welcome"},
        { code: "custcollab", name: "Collaboration"},
        { code: "custfeedback", name: "Feedback"},
        { code: "custcomm", name: "Communication"},
        { code: "xdoma1", name: "SRH Pulse Questions"},
        { code: "rntmcollab", name: "RN-to-RN Teamwork and Collaboration"},
        { code: "aut", name: "Autonomy"},
        { code: "fundqnc", name: "Fundamentals of Quality Nursing Care"},
        { code: "profdev", name: "Professional Development"},
        { code: "leadaccessresp", name: "Leadership Access and Responsiveness"},
        { code: "psychsafe", name: "Psychological Safety"},
        { code: "tmcomm", name: "Teamwork and Communication"}
      ];
      const domainComponents = {};
      for (let i = 0; i < domains.length; i++) {
        const domain = domains[i];
        const questionComponents = _.chain(surveyQuestions)
          .filter(question => {
            return question.domain === domain.code;
          })
          .map(question => {
            if (unit) {
              let facilityQuestion = JSON.parse(JSON.stringify(question));
              facilityQuestion.column = `${facilityQuestion.column}-facility`;
              facilityQuestion = this.getValuesFromQuestion(facilityQuestion, currentGroupName, prevGroupName);
              question = this.getValuesFromQuestion(question, currentGroupName, prevGroupName);
              question.facilityPositive = facilityQuestion.positive;
              return question;
            } else {
              return this.getValuesFromQuestion(question, currentGroupName, prevGroupName);
            }
          })
          // .sortBy(results => {
          //   return results.percentile;
          // })
          // .sortBy(results => {
          //   if (results.showStrain) {
          //     return results.percentile;
          //   } else {
          //     return results.neutral * -1;
          //   }
          // })
          // .sortBy(results => {
          //   if (results.showStrain) {
          //     return results.strained;
          //   } else {
          //     return results.positive * -1;
          //   }
          // })
          .map(results => {
            const {
              column,
              domain,
              question,
              positive,
              facilityPositive,
              showChange,
              change,
              percentile,
              insufficientData,
            } = results;
            let sutterPercent;
            if (column === "leinput") {
              sutterPercent = "69";
            } else if (column === "lefixdefct") {
              sutterPercent = "67";
            } else if (column === "psyposfb") {
              sutterPercent = "71";
            } else if (column === "eemeburn") {
              sutterPercent = "36";
            } else if (column === "spkupclt") {
              sutterPercent = "59";
            } else if (column === "comdelay") {
              sutterPercent = "42";
            } else if (column === "cultlearn") {
              sutterPercent = "65";
            } else if (column === "feelsafe") {
              sutterPercent = "79";
            } else if (column === "phys_safety") {
              sutterPercent = "80";
            }
            return (
              <Question key={column}>
                <div className="background">
                  <div className="background2">
                    <p className={clsx({ squish: reportType === "sutter", "question-landscape": landscape })}>
                      {question}
                    </p>
                  </div>
                </div>
                <div className={`data ${reportType} ${!sutterUnitReport ? "sutter-affiliate-report" : ""}`}>
                  <div
                    className={`percent ${
                      reportType === "sutter" && !sutterUnitReport ? "percent-2-of-3" : "percent-1-of-3"
                    }`}
                  >
                    {insufficientData ? "--" : positive}%
                  </div>
                  {showChange && (
                    <div className={`percent-change ${change > 0 ? "positive" : change < 0 ? "negative" : ""}`}>
                      {Math.abs(change)}%{change > 0 ? " ↑" : change < 0 ? " ↓" : ""}
                    </div>
                  )}
                  {reportType === "unit" && <div className="percent-facility">{facilityPositive}%</div>}
                  {reportType === "sutter" &&
                    !sutterUnitReport && <div className="column percent-3-of-3">{sutterPercent}%</div>}
                  {reportType === "sutter" &&
                    sutterUnitReport && <div className="column percent-3-of-4">{facilityPositive}%</div>}
                  {reportType === "sutter" &&
                    sutterUnitReport && <div className="column percent-4-of-4">{sutterPercent}%</div>}
                  <div className="percentile" style={{ paddingLeft: domain === "ee" ? "7px" : "" }}>
                    {insufficientData ? "--" : this.displayPercentile(percentile)}
                    {(domain === "ee" || domain === "me") && <sup>†</sup>}
                  </div>
                </div>
              </Question>
            );
          })
          .value();

        domainComponents[domain.code] = (
          <Domain key={domain.code}>
            <h4>{domain.name === "Learning Environment" ? "Improvement Readiness" : domain.name}</h4>
            {domainPrefixes[domain.code] && <p className="question-prefix">{domainPrefixes[domain.code]}</p>}
            <div>{questionComponents}</div>
          </Domain>
        );

      }

      const pages = [];
      let pageConfiguration;
      const domainScoresConfiguration =
        configuration && configuration.domain_scores && configuration.domain_scores.pages;
      if (domainScoresConfiguration) {
        pageConfiguration = landscape ? domainScoresConfiguration.landscape : domainScoresConfiguration.portrait;
      }
      if (pageConfiguration) {
        pageConfiguration.map((page, index) =>
          pages.push(
            this.getPage(
              page.map(domain => domainComponents[domain]),
              index,
              summaryReport,
              unit,
              reportType,
              sutterUnitReport,
              landscape
            )
          )
        );
      } else if (reportType === "sutter") {
        const { le, ll, me, tm, sc, ps } = domainComponents;
        pages.push(
          this.getPage([le, ll, me, tm, sc, ps], 0, summaryReport, unit, reportType, sutterUnitReport, landscape)
        );
      } else if (reportSubType === "sutter_acute") {
        const { le, ll, tm, sc, go, dm } = domainComponents;
        pages.push(
          this.getPage([le, ll, tm, sc, go, dm], 0, summaryReport, unit, reportType, sutterUnitReport, landscape)
        );
      } else if (reportSubType === "sutter_amb") {
        const { tm, sc } = domainComponents;
        pages.push(this.getPage([tm, sc], 0, summaryReport, unit, reportType, sutterUnitReport, landscape));
      } else if (survey === "SCOR_Pulse") {
        const { le, ll, ee, tm, sc, wlb } = domainComponents;
        pages.push(
          this.getPage([le, ll, ee, tm, sc, wlb], 0, summaryReport, unit, reportType, sutterUnitReport, landscape)
        );
      }
      return <Wrapper>{pages}</Wrapper>;
    } else {
      return <Printable landscape={landscape} />;
    }
  }
}
export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    domainScores: store.domainScores.domainScores,
    questions: store.questions,
  };
})(Questions);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/PulseQuestions/index.jsx